import React, { useEffect, useRef, useState } from 'react';
import { ApiService, useProovedorData } from '../../components'
import { useNavigate } from 'react-router-dom';
import styles from './sendAccess.module.css';
import HosmingLogo from '../../images/logo-hosming.png'

const SendAccess = () => {
    const navigate = useNavigate();
    const { shareDetected, setShareDetected } = useProovedorData() || [];
    const [stateRequest, setStateRequest] = useState(false);

    useEffect(() => {
        const obj_transfer = sessionStorage.getItem('extracted_data');
        if (!window.opener && shareDetected?.origin == null) navigate('/');
        else window.opener.postMessage("I'm ready", '*');

        if (obj_transfer) {
            const ot_converted = JSON.parse(obj_transfer);

            if (ot_converted?.origin == null) navigate('/');

            if (ot_converted?.origin != null && ot_converted?.phone != null) setShareDetected(ot_converted);
            else getSecretAccess(ot_converted.origin);
        } else {
            const handleMessage = (event) => {
                if (event?.data?.message != null && event?.data?.origin != null && shareDetected?.origin == null) getSecretAccess(event?.data?.origin);
            };

            window.addEventListener('message', handleMessage);

            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, []);

    async function getSecretAccess(extra_data = "") {
        try {
            setStateRequest(true);
            const response_fetch = await ApiService.fetchData('api/auth/access-request', {
                method: 'post',
                body: JSON.stringify({ origin: extra_data })
            });

            if (response_fetch?.message != null) return;

            const result = {
                origin: extra_data,
                secret_access: response_fetch
            };

            setShareDetected(result);
            sessionStorage.setItem('extracted_data', JSON.stringify(result));
        } finally {
            setStateRequest(false);
        }
    }

    function sendDataUser() {
        if (window.opener) {
            window.opener.postMessage(shareDetected, '*');
            window.close();
        }
    }


    const bgRef = useRef(null);

    // const createNodes = () => {
    //     const bg = bgRef.current;
    //     if (!bg) return;

    //     // Limpiar nodos anteriores si lo deseas
    //     bg.innerHTML = '';

    //     for (let i = 0; i < 20; i++) {
    //         const node = document.createElement('div');
    //         node.className = 'node';
    //         node.style.left = Math.random() * 100 + '%';
    //         node.style.top = Math.random() * 100 + '%';
    //         node.style.animationDelay = Math.random() * 6 + 's';
    //         bg.appendChild(node);

    //         const line = document.createElement('div');
    //         line.className = 'line';
    //         line.style.left = Math.random() * 100 + '%';
    //         line.style.top = Math.random() * 100 + '%';
    //         line.style.transform = `rotate(${Math.random() * 360}deg)`;
    //         line.style.animationDelay = Math.random() * 4 + 's';
    //         bg.appendChild(line);
    //     }
    // };

    // useEffect(() => {
    //     createNodes();
    //     const interval = setInterval(createNodes, 5000);

    //     return () => clearInterval(interval); // ✅ Limpiar intervalo al desmontar
    // }, []);

    return (
        <div style={{
            fontFamily: 'Arial, sans-serif',
            background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)',
            color: '#ffffff',
            height: '100vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
        }}>
            {/* 🔧 ref agregado aquí */}
            <div className={styles.connectionBg} ref={bgRef}></div>

            <img
                src={HosmingLogo}
                alt="Logo Hosming"
                className={styles.logo}
            />

            <p className={styles.welcomeText}>
                ¡Bienvenido a Hosming!
                <br></br>
                Estás a punto de acceder a una de nuestras páginas asociadas.
                Para continuar, haz clic en "Enviar Acceso" esto compartirá tu llave de acceso de forma segura y te llevará directamente a descubrir todas las funcionalidades que tenemos para ti.
            </p>

            <button
                className={styles.btnEnviar}
                onClick={sendDataUser}
                disabled={stateRequest}
                style={{ opacity: stateRequest ? '0.5' : '1' }}
            >
                Enviar Acceso
            </button>
        </div>
    );

};

export default SendAccess;
